import * as React from "react";
import { createBrowserRouter, RouterProvider, useNavigate } from "react-router-dom";
import SignUp from "@/components/onboarding/SignUp";
import RejectedScreen from "@/components/journey/RejectedScreen";
import MembershipBenefitsScreen from "@/components/onboarding/MembershipBenefitsScreen";
import ErrorScreen from "@/components/journey/ErrorScreen";
import NotifyScreen from "@/components/journey/NotifyScreen";
import ViewLandlordOffer from "./components/journey/ViewLandlordOffer";
import Layout from "@/components/layout";
import FAQScreen from "@/components/journey/FAQScreen";
import CongratsScreen from "@/components/journey/CongratsScreen";
import ByeUserScreen from "@/components/journey/ByeUserScreen";
import HomeScreen from "@/b2b/pages/HomeScreen.jsx";
import PartnerScreen from "@/b2b/pages/PartnerScreen.jsx";
import DynamicGuardedScreen from "@/components/common/screens/DynamicGuardedScreen";
import DynamicHomeScreen from "@/components/common/screens/DynamicHomeScreen";
import SuccessScreen from "@/components/journey/SuccessScreen";
import ProcessingScreen from "@/components/journey/ProcessingScreen";
import LoadingScreen from "./components/common/screens/LoadingScreen";
import TransitionWrapper from "./components/TransitionWrapper";
import { AnimatePresence } from "framer-motion";
import ReferScreen from "@/components/journey/ReferScreen";
import ReferHistoryScreen from "@/components/journey/ReferHistoryScreen";
import NewBenefits from "./components/onboarding/NewBenefits";
import { ThemeProvider } from "@/b2b/context/ThemeContext";
import RentingStatusScreen from "./components/onboarding/RentingStatusScreen";
import LandlordProceed from "./components/journey/LandlordProceed";
import StartScreen from "@/components/onboarding/StartScreen";
import InviteAcceptanceScreen from "@/components/landlord/InviteAcceptanceScreen";
import LandlordBenefits from "@/components/landlord/LandlordBenefits";
import PlatformChargesScreen from "@/components/landlord/PlatformChargesScreen";
import VishalSteps from "@/components/banking/home";
import WorkDetails from "@/components/banking/WorkDetails";
// import FlatmateInviteScreen from "@/components/onboarding/FlatmateInviteScreen";
import TenantTrackingScreen from "@/components/landlord/TenantTrackingScreen";
import FurtherSteps from "./components/journey/FurtherSteps";
import RedirectPage from "@/components/onboarding/RedirectPage";
import mixpanel from "mixpanel-browser";
import BankingLimitExceededScreen from "@/b2b/pages/BankingLimitExceededScreen";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import NewSplash from "./components/common/screens/newSplash";
import ClubWorkScreen from "./components/common/screens/ClubWorkScreen";
import CirclePeOffers from "./components/common/screens/calculatorScreen";
import ProcessDisbursal from "./components/banking/ProcessDisbursal";
import KYC from "./components/banking/kyc/index.jsx";
import PennyDrop from "./components/banking/bank_details/PennyDrop";
import BankDetails from "./components/banking/bank_details";
import RentSummary from "./components/banking/RentSummary";
import ESign from "./components/banking/esign";
import Mandate from "./components/banking/mandate";
// import Cards from "./components/common/screens/NewCarousel";
import AppDownloadBanner from "./components/common/DownloadAppBanner";

import NoAuthTransitionWrapper from "./components/NoAuthTransitionWrapper";
import  config  from "@/config";
import { PostHogProvider } from 'posthog-js/react';

import { useSocket } from "@/socketprovider";
import router from "./router";
import { useLoadLenderConfig } from "@/lib/lender";
export default function App() {
  useLoadLenderConfig();

  return (
   
    <AnimatePresence mode="wait">
      <PostHogProvider
        apiKey={config.posthhogkey}
        options={{
          api_host: "https://us.i.posthog.com",
       
        }}
      >
        {/* {!["android_app", "ios_app", "mobile_unknown_app", "mobileApp"].includes(
            localStorage.getItem("UTM_SOURCE")
          ) && <AppDownloadBanner />} */}
        <RouterProvider router={router} />
      </PostHogProvider>
    </AnimatePresence>

  );
}
